'use client'
import React from 'react'

type Props = {
  comment?: string | number
  thumbs?: string | number
}

export default function TopBanner({ comment, thumbs }: Props) {
  return (
    <div className="boardListInfoArea">
      {comment !== undefined && comment !== null && (
        <div>
          <img src="/icon/comment_icon.png" alt="" />
          <span>{comment}</span>
        </div>
      )}

      {thumbs !== undefined && thumbs !== null && (
        <div>
          <img src="/icon/thums_icon.png" alt="" />
          <span>{thumbs}</span>
        </div>
      )}
    </div>
  )
}
